/*
 * @Author: pengyong
 * @Date: 2019-09-04 10:03:10
 * @LastEditors: pengyong
 * @LastEditTime: 2020-12-08 21:51:03
 * @Description:
 * @FilePath: /exhibit/src/store.js
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "@/api";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        showChildId: 0,
        hideUserModalSideBar: false, // 隐藏个人中心sidebar
        showUserModal: false, // 显示个人中心弹窗
        userInfo: localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")) : {},
        // userInfo: {},
        show: true,
        currentExhibition: '',
        language: localStorage.getItem("language") || 'zh',
        isLogin: localStorage.getItem('isLogin') || 0
    },
    mutations: {
        setState(state, payload) {
            for (let key in payload) {
                state[key] = payload[key];
                if (key === "showUserModal" && !payload[key]) {
                    state.hideUserModalSideBar = false;
                    state.showChildId = 0;
                }
                payload.cache ? localStorage.setItem(key, JSON.stringify(payload[key])) : null;
            }
        },
        setLanguage(state, payload){
            state.language = payload
        },
        setLoginStatus(state, payload) {
            state.isLogin = payload
            localStorage.setItem('isLogin', payload)
        }
    },
    actions: {
        getUserInfo({ commit }) {
            return new Promise((resolve, reject) => {
                if (localStorage.getItem("access_token")) {
                    api.getUserInfo().then((res) => {
                        if (res.res === 1) {
                            commit("setState", {
                                userInfo: res.data
                            });
                            commit("setLoginStatus", 1);
                            localStorage.setItem("userInfo", JSON.stringify(res.data));
                            resolve(res);
                        }
                    });
                }
            });
        }
    }
});



// WEBPACK FOOTER //
// ./src/store.js